import React from "react";
export const WidgetConfigurationContext = React.createContext(undefined);
/**
 * Gives you access to the current widget configuration
 */
export function useWidgetConfiguration() {
    // We know it is not null as the framework always sets the provider with a correct value
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return React.useContext(WidgetConfigurationContext).widgetConfiguration;
}
/**
 * HOC to give access to the widget configuration to class based components
 */
export function withWidgetConfiguration(UnwrappedComponent) {
    const wrapper = (props) => (<WidgetConfigurationContext.Consumer>
      {(context) => <UnwrappedComponent {...props} {...context}/>}
    </WidgetConfigurationContext.Consumer>);
    wrapper.displayName = `WithWidgetConfiguration(${UnwrappedComponent.displayName || "Component"})`;
    return wrapper;
}
/**
 * Access to your widget's environment specific configuration
 */
export function useMyWidgetConfiguration() {
    const configuration = useWidgetConfiguration();
    const [myConfiguration, setMyConfiguration] = React.useState();
    React.useEffect(() => {
        let isMounted = true;
        (async function () {
            const r = await configuration.myConfiguration();
            if (isMounted)
                setMyConfiguration(r);
        })();
        return () => {
            isMounted = false;
        };
    }, [configuration]);
    return myConfiguration;
}
